import { gql } from '@apollo/client';

export const GET_EQUIPMENT_QUOTE_BY_VO_ID = gql`
  query Quote($vendorOpportunityId: ID!) {
    vendorOpportunity(id: $vendorOpportunityId) {
      quote {
        quoteId
        vendorOpportunityId
        externalCrmVendorOpportunityId
        daysToFirstPayment
        firstPaymentDueDate
        contractStartDate
        interestRate
        paymentAmount
        term
        attributes {
          key
          description
          value
        }
        feesTotal
        fees {
          type
          description
          amount
          equipmentId
        }
        aftermarketProducts {
          type
          description
          cost
          equipmentId
        }
        aftermarketProductsTotal
        rebates {
          description
          amount
          equipmentId
        }
        rebatesTotal
        cashBackAmounts {
          description
          amount
          equipmentId
        }
        cashBackAmountsTotal
        tradeValueNet
        tradeValueGross
        tradeValueOwed
        equipment {
          equipmentId
          externalId
          vin
          stockNumber
          cost
          attributes {
            key
            description
            value
          }
        }
        equipmentTradeIns {
          equipmentId
          externalId
          vin
          stockNumber
          tradeInDetails {
            tradeValue
            tradeAmountOwed
          }
          attributes {
            key
            description
            value
          }
        }
        equipmentSubtotal
        downPayment
        financedAmount
        active
        createdDateTime
        modifiedDateTime
      }
    }
  }
`;
